import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { UserGroupService } from "../services/UserGroupService";
import {
    createGroupDetailModel, createProductKeyModel, createProductLineModel, createProductModel,
    GroupDetailModel, ProductKeyModel, ProductLineModel, ProductModel
} from "../models/ProductModel";
import { useState } from "react";
import { PictureModel } from "../../pictures/models/PictureModel";
import { UserProductLineService } from "../services/UserProductLineService";
import { baseUrlUser } from "../../../constants/url.constant";

export default function useProductDetailVM() {
    const groupService = new UserGroupService();
    const lineService = new UserProductLineService();

    const [group, setGroup] = useState<GroupDetailModel>(createGroupDetailModel());
    const [selectedLine, setSelectedLine] = useState<ProductLineModel>(createProductLineModel());
    const [selectedProduct, setSelectedProduct] = useState<ProductModel>(createProductModel());

    const [selectedKey, setSelectedKey] = useState<ProductKeyModel>(createProductKeyModel());
    const [pictures, setPictures] = useState<string[]>([]);

    const get = (key: ProductKeyModel) => {
        var request = null;

        if (key.groupId <= 0) {
            request = groupService.getDetailByLineId(key.lineId);
        } else {
            request = groupService.getDetail(key.groupId);
        }

        setSelectedKey(key);

        const onResult = (result: IDataResult) => {
            if (result.status === ResponseStatus.success) {
                setValues(key, result.data);
            }
        }

        DataUtils.onRequest(request, onResult);
    }

    const setValues = (key: ProductKeyModel, group: GroupDetailModel) => {
        setGroup(group);

        const lines = group.lines;

        if (lines.length > 0) {
            const defaultLine = lines.find(
                (line: ProductLineModel, index: number) => line.id === key.lineId
            );

            const newSelectedLine = defaultLine ?? lines[0];
            const products = newSelectedLine.products;

            setSelectedLine(newSelectedLine);

            if (products.length > 0) {
                const defaultProduct = products.find(
                    (product: ProductModel, index: number) => product.id === key.productId
                );

                setSelectedProduct(defaultProduct ?? products[0]);
            }
        }
    }

    const changeInGroup = (newKey: ProductKeyModel) => {
        setSelectedKey(newKey);
        setValues(newKey, group);
        getPictures(newKey.lineId);
    }

    const getPictures = (lineId: number) => {
        setPictures([]);

        const onRequest = (result: IDataResult) => {
            if (result.status === ResponseStatus.success) {
                let pictures = result.data as PictureModel[];

                if (pictures) {
                    const imageUrls = pictures.map((picture) => baseUrlUser + picture.imageUrl);
                    setPictures(imageUrls);
                }
            }
        }

        const request = lineService.getPictures(lineId);
        DataUtils.onRequest(request, onRequest);
    }

    return {
        group,
        selectedLine,
        selectedProduct,
        selectedKey,
        pictures,

        get,
        getPictures,
        changeInGroup
    }
}